module.exports = __webpack_public_path__ + "static/media/academic.73c88f04.svg";